module.exports = __webpack_public_path__ + "img/img_level_1.06141cf2.png";